import { Befehl8 } from '../../../models'
import { Befehl8FormData, Befehl8FormSchema } from './schema'
import { BefehlAuftrag_8_50Dto } from '../../../dtos'
import {
  Befehl8DataDto,
  Feld_8_43Dto,
  Feld_8_44Dto,
  Feld_8_51_1Dto,
  Feld_8_52_1Dto,
  Feld_8_53_1Dto,
  Feld_8_54_1Dto,
  Feld_8_55_1Dto,
  Feld_8_56_1Dto
} from '../../../dtos/befehl-8-dto'
import {
  findAuftragByKennung,
  isSelectorInOrZwischen
} from '../converter-utils'

export const convertModelToBefehl8FormData = (
  befehl?: Befehl8
): Befehl8FormData => {
  const formData = Befehl8FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag850 = findAuftragByKennung(befehl.auftraege, '8.50')
  if (!auftrag850) {
    return formData
  }

  formData.auftrag_8_50.enabled = true
  const zeilen: Array<string | undefined> = [
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined
  ]

  for (const feld of auftrag850.felder) {
    switch (feld.kennung) {
      case '8.43': {
        const feld8_43 = feld
        formData.auftrag_8_50.field_x_43 = {
          art: feld8_43.werte?.zugmeldestelle?.art ?? '',
          name: feld8_43.werte?.zugmeldestelle?.name ?? ''
        }
        formData.auftrag_8_50.selector = 'in'
        break
      }
      case '8.44': {
        const feld8_44 = feld
        formData.auftrag_8_50.field_x_44 = {
          art: feld8_44.werte?.zugmeldestelle?.art ?? '',
          name: feld8_44.werte?.zugmeldestelle?.name ?? ''
        }
        formData.auftrag_8_50.selector = 'zwischen'
        break
      }
      case '8.51.1': {
        const feld_8_51_1 = feld
        zeilen[0] = feld_8_51_1.werte.km || ''
        break
      }
      case '8.52.1': {
        const feld_8_52_1 = feld
        zeilen[1] = feld_8_52_1.werte.km || ''
        break
      }
      case '8.53.1': {
        const feld_8_53_1 = feld
        zeilen[2] = feld_8_53_1.werte.km || ''
        break
      }
      case '8.54.1': {
        const feld_8_54_1 = feld
        zeilen[3] = feld_8_54_1.werte.km || ''
        break
      }
      case '8.55.1': {
        const feld_8_55_1 = feld
        zeilen[4] = feld_8_55_1.werte.km || ''
        break
      }
      case '8.56.1': {
        const feld_8_56_1 = feld
        zeilen[5] = feld_8_56_1.werte.km || ''
        break
      }
    }
  }

  const definedZeilen = zeilen.filter((zeile) => zeile !== undefined)
  formData.auftrag_8_50.kmZeilen = definedZeilen

  return formData
}

export const convertBefehl8FormDataToModel = (
  data: Befehl8FormData,
  frontendId: string
): Befehl8 => {
  const auftraege: Befehl8DataDto = []

  if (data.auftrag_8_50?.enabled) {
    const auftrag8_50: BefehlAuftrag_8_50Dto = {
      kennung: '8.50',
      felder: []
    }

    if (isSelectorInOrZwischen(data.auftrag_8_50?.selector)) {
      auftrag8_50.felder.push({
        kennung: '8.43',
        werte: {
          zugmeldestelle: {
            art: data.auftrag_8_50?.field_x_43?.art ?? '',
            name: data.auftrag_8_50?.field_x_43?.name ?? ''
          }
        }
      } as Feld_8_43Dto)

      if (data.auftrag_8_50?.selector === 'zwischen') {
        auftrag8_50.felder.push({
          kennung: '8.44',
          werte: {
            zugmeldestelle: {
              art: data.auftrag_8_50?.field_x_44?.art ?? '',
              name: data.auftrag_8_50?.field_x_44?.name ?? ''
            }
          }
        } as Feld_8_44Dto)
      }
    }

    const kmKennungen = [
      '8.51.1',
      '8.52.1',
      '8.53.1',
      '8.54.1',
      '8.55.1',
      '8.56.1'
    ]
    if (data.auftrag_8_50) {
      for (const [index, zeile] of data.auftrag_8_50.kmZeilen.entries()) {
        if (index < kmKennungen.length) {
          auftrag8_50.felder.push({
            kennung: kmKennungen[index],
            werte: { km: zeile ?? '' }
          } as
            | Feld_8_51_1Dto
            | Feld_8_52_1Dto
            | Feld_8_53_1Dto
            | Feld_8_54_1Dto
            | Feld_8_55_1Dto
            | Feld_8_56_1Dto)
        }
      }
    }

    auftraege.push(auftrag8_50)
  }

  return {
    kennung: '8',
    frontendId,
    auftraege
  }
}
